module.exports = __webpack_public_path__ + "img/upload.15656379.svg";